module.exports = __webpack_public_path__ + "src/fonts/NotoSans-BoldItalic.251a9795e9cea09fb278c4f8efa87f44.ttf";